import { useTranslation } from 'react-i18next';

import { IconComponent } from 'src/components/Icons/TextIcon';

type ModuleUnavailableStateProps = {
    icon: IconComponent;
    moduleName: string;
    reason: 'notEnabled' | 'accessRequired';
};

export const ModuleUnavailableState = ({
    icon,
    moduleName,
    reason,
}: ModuleUnavailableStateProps) => {
    const { t } = useTranslation();
    const notEnabled = reason === 'notEnabled';
    const ModuleIcon = icon;

    return (
        <div className="w-full flex justify-center px-4 py-16 text-woodyBrown">
            <div className="max-w-md text-center">
                <span className="relative mx-auto mb-4 block h-8 w-8 stroke-[1.6px] opacity-40">
                    <ModuleIcon />
                </span>
                <h2 className="font-logo text-xl">
                    {t(
                        notEnabled
                            ? 'modules.moduleUnavailable.notEnabledTitle'
                            : 'modules.moduleUnavailable.accessRequiredTitle',
                        { module: moduleName },
                    )}
                </h2>
                <p className="mt-2 text-sm leading-6 opacity-70">
                    {t(
                        notEnabled
                            ? 'modules.moduleUnavailable.notEnabledDescription'
                            : 'modules.moduleUnavailable.accessRequiredDescription',
                    )}
                </p>
                <p className="mt-1 text-sm leading-6 opacity-70">
                    {t(
                        notEnabled
                            ? 'modules.moduleUnavailable.notEnabledHelp'
                            : 'modules.moduleUnavailable.accessRequiredHelp',
                    )}
                </p>
            </div>
        </div>
    );
};
